var map = {
	"./blackGold/main/audio_icon.png": 26769,
	"./brownGold/main/audio_icon.png": 76113,
	"./darkBlue/main/audio_icon.png": 91363,
	"./greenYellow/main/audio_icon.png": 46213,
	"./redGold/main/audio_icon.png": 44640,
	"./skyBlue/main/audio_icon.png": 85884,
	"./whiteGold/main/audio_icon.png": 47293,
	"./yellowWhite/main/audio_icon.png": 22355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83209;